import { useMemo } from 'react';

import { type FilterToolbarSchema } from '@/components/composed';

export const useUsersFiltersSchema = (): FilterToolbarSchema =>
  useMemo<FilterToolbarSchema>(
    () => ({
      search: {
        name: 'query',
        placeholder: 'Search by user or address…',
        debounceMs: 500,
      },
      chips: [],
    }),
    [],
  );
